module.exports = __webpack_public_path__ + "officialStatic/img/mdu-detailList12.c4ec5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/mdu-detailList12.png
// module id = hn5X
// module chunks = 0